import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=279e627c&scoped=true&"
import script from "./NewTemplate.vue?vue&type=script&lang=js&"
export * from "./NewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&id=279e627c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e627c",
  null
  
)

export default component.exports